import {
  Component, Inject, OnDestroy, OnInit,
} from '@angular/core';
import {
  MAT_DIALOG_DATA, MatDialog, MatDialogRef,
} from '@angular/material/dialog';
import { CatalogSuggestionsService } from 'src/app/services/catalog-suggestions.service';

@Component({
  selector: 'app-catalog-suggestions-details',
  templateUrl: './catalog-suggestions-details.component.html',
  styleUrls: [ './catalog-suggestions-details.component.scss' ],
})
export class CatalogSuggestionsDetailsComponent implements OnInit, OnDestroy {
  course: any = {
    catalogSuggestionId: '',
    name: '',
    creditHours: '',
    courseType: '',
    instructor: '',
    cost: '',
    webUrl: '',
    description: '',
    async: false,
    virtual: false,
    anytime: false,
    location: '',
    roomNumber: '',
    courseDate: '',
    startTime: '',
    endTime: '',
  }
  isLoading: any;
  catalogSuggestionSubscription: any;

  constructor(
    public dialogRef: MatDialogRef<CatalogSuggestionsDetailsComponent>,
    public dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: any,
    private catalogSuggestionsService: CatalogSuggestionsService,
  ) { }

  ngOnInit(): void {
    this.loadCatalogSuggestion();
  }

  loadCatalogSuggestion(): void {
    this.isLoading = true;
    this.catalogSuggestionSubscription = this.catalogSuggestionsService.getCatalogSuggestion(this.data.id).subscribe({
      next: (response: any) => {
        try {
          // The response structure: data is the course, data.CourseItems[0] is the course item
          const course = response?.data || {};
          const courseItem = course?.CourseItems?.[0] || {};
          
          const isAsync = courseItem?.preRecordedOption === 'ASYNC';
          const isAnytime = courseItem?.preRecordedOption === 'ANYTIME';
          
          this.course = {
            ...course,
            ...courseItem,
            name: course?.courseName || '',
            creditHours: course?.trackingValue || '',
            courseType: course?.CourseType?.courseType || course?.courseType || '',
            instructor: courseItem?.instructor || null,
            cost: course?.courseCost || null,
            webUrl: courseItem?.hyperlink || null,
            description: course?.courseDescription || '',
            async: isAsync,
            virtual: courseItem?.virtualFlag === 1,
            anytime: isAnytime,
            location: courseItem?.location || '',
            roomNumber: courseItem?.roomNumber || null,
            courseDate: isAsync ? 'Async' : (courseItem?.dateOffered ? new Date(courseItem.dateOffered).toLocaleDateString() : ''),
            startTime: isAnytime ? 'Anytime' : (courseItem?.sessionStartDate ? new Date(courseItem.sessionStartDate).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' }) : ''),
            endTime: isAnytime ? 'Anytime' : (courseItem?.sessionEndDate ? new Date(courseItem.sessionEndDate).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' }) : ''),
            // Ensure CourseItems is included
            CourseItems: course?.CourseItems || [],
            // Preserve IDs
            courseItemId: courseItem?.id || null,
            courseId: course?.id || courseItem?.courseId || null,
          }
        } catch (error) {
          console.error('Error processing catalog suggestion data:', error);
        } finally {
          this.isLoading = false;
        }
      },
      error: (error: any) => {
        console.error('Error getting catalog suggestion', error);
        this.isLoading = false;
      },
    });
  }

  closeModal(action?: 'approve' | 'deny'): void {
    this.dialogRef.close(action);
  }

  ngOnDestroy(): void {
    this.catalogSuggestionSubscription.unsubscribe();
  }

}